<template>
  <div>
    <a-card style="margin:20px">
      <template #title>
        <div class="top-title">
          <div class="left">
            <span>账户管理</span>
            <a-icon type="right"/>
            <span>提款与还款记录</span>
          </div>
        </div>
      </template>
      <template slot="extra">
        <a-button @click="toBack">返回</a-button>
      </template>

      <div class="loan-repay-record">
        <div>
          <a-tabs v-model="activeKey" @change="callback">
            <a-tab-pane key="loan" tab="提款">
              <!-- 修改后的loanForm表单布局 -->
              <div class="formbox">
                <a-form-model ref="loanForm" :model="loanForm" class="horizontal-form" :label-col="labelCol" :wrapper-col="wrapperCol">
                  <a-form-model-item label="提款日期" prop="tradeDate" class="form-item">
                    <a-date-picker style="width: 100%" placeholder="请选择提款日期" v-model="loanForm.tradeDate" valueFormat="YYYY-MM-DD" allowClear/>
                  </a-form-model-item>
                  <a-form-model-item label="合同编号" prop="contractNo" class="form-item">
                    <a-input placeholder="请输入合同编号" v-model="loanForm.contractNo"/>
                  </a-form-model-item>
                  <a-form-model-item label="借据号" prop="loanacctno" class="form-item">
                    <a-input placeholder="请输入贷款账号" v-model="loanForm.loanacctno"/>
                  </a-form-model-item>
                  <div class="form-actions">
                    <a-button type="primary" @click="getCreditLoanList">查询</a-button>
                    <a-button @click="resetLoanForm">重置</a-button>
                    <a-button type="primary" icon="download" @click="creditLoanInfoExport">导出</a-button>
                  </div>
                </a-form-model>
              </div>

              <div class="table-box">
                <a-table :columns="loanColumns" :data-source="loanData" :row-key="(record) => record.id" :pagination="false" bordered size="small">
                </a-table>
                <div class="pagination-wrapper">
                  <LcfsPagination :page-no.sync="loanPagination.pageNo" :page-size.sync="loanPagination.pageSize" :total="loanPagination.total"
                                  :fn="getCreditLoanList"/>
                </div>
              </div>
            </a-tab-pane>

            <a-tab-pane key="repay" tab="还款" force-render>
              <!-- 修改后的repayForm表单布局 -->
              <div class="formbox">
                <a-form-model ref="repayForm" :model="repayForm" class="horizontal-form" :label-col="labelCol" :wrapper-col="wrapperCol">
                  <a-form-model-item label="还款日期" prop="tradeDate" class="form-item">
                    <a-date-picker style="width: 100%" placeholder="请选择还款日期" v-model="repayForm.tradeDate" valueFormat="YYYY-MM-DD" allowClear/>
                  </a-form-model-item>
                  <a-form-model-item label="合同编号" prop="contractNo" class="form-item">
                    <a-input placeholder="请输入合同编号" v-model="repayForm.contractNo"/>
                  </a-form-model-item>
                  <a-form-model-item label="借据号" prop="loanAcctNo" class="form-item">
                    <a-input placeholder="请输入贷款账号" v-model="repayForm.loanAcctNo"/>
                  </a-form-model-item>
                  <div class="form-actions">
                    <a-button type="primary" @click="getCreditRepayList">查询</a-button>
                    <a-button @click="resetRepayForm">重置</a-button>
                    <a-button type="primary" icon="download" @click="creditRepayInfoExport">导出</a-button>
                  </div>
                </a-form-model>
              </div>
              <div class="table-box">
                <a-table :columns="repayColumns" :data-source="repayData" :row-key="(record) => record.id" :pagination="false" bordered size="small">
                </a-table>
                <div class="pagination-wrapper">
                  <LcfsPagination :page-no.sync="repayPagination.pageNo" :page-size.sync="repayPagination.pageSize" :total="repayPagination.total"
                                  :fn="getCreditRepayList"/>
                </div>
              </div>
            </a-tab-pane>
          </a-tabs>
        </div>
      </div>
    </a-card>

    <a-modal v-model="repayVisible" width="75%" :bodyStyle="{ height: 'auto', minHeight: '30vh', maxHeight: '70vh' }"
             @ok="repayVisible=false" :closable="false">

      <a-descriptions title="贷款详情" bordered>
        <!-- 基本信息 -->
        <a-descriptions-item label="贷款类型">
          {{ repayDetails[0]?.loantp === 'c' ? '信用贷款' : '未知' }}
        </a-descriptions-item>
        <a-descriptions-item label="年利率">
          {{ repayDetails[0]?.yrintrate }}%
        </a-descriptions-item>
        <a-descriptions-item label="借据号">
          {{ repayDetails[0]?.loanacctno }}
        </a-descriptions-item>
        <a-descriptions-item label="发放日期">
          {{ repayDetails[0]?.lndngdt }}
        </a-descriptions-item>
        <a-descriptions-item label="还款日期">
          {{ repayDetails[0]?.rpybldt }}
        </a-descriptions-item>
        <a-descriptions-item label="合同编号">
          {{ repayDetails[0]?.ctrno }}
        </a-descriptions-item>
        <a-descriptions-item label="发放金额">
          <Balance :alignRight="false" :amount="repayDetails[0]?.dstrbtintrate"/>
        </a-descriptions-item>
        <a-descriptions-item label="应收利息">
          <Balance :alignRight="false" :amount="repayDetails[0]?.actintamt"/>
        </a-descriptions-item>
        <!-- 贷款状态和形态 -->
        <a-descriptions-item label="贷款状态">
          <a-tag
              :style="{ color: commonDict.loanStatusConfig[repayDetails[0]?.loanst]?.color || commonDict.loanStatusConfig.default.color }">
            {{ commonDict.loanStatusConfig[repayDetails[0]?.loanst]?.label || commonDict.loanStatusConfig.default.label }}
          </a-tag>
        </a-descriptions-item>
        <a-descriptions-item label="已还本金">
          <Balance :alignRight="false" :amount="repayDetails[0]?.actrepymtpnpamt"/>
        </a-descriptions-item>
        <a-descriptions-item label="已还利息">
          <Balance :alignRight="false" :amount="repayDetails[0]?.acmclctintamt"/>
        </a-descriptions-item>
        <a-descriptions-item label="还款方式">
          <a-tag
              :style="{ color: commonDict.repaymentMethodConfig[repayDetails[0]?.repymtmd]?.color ||  commonDict.repaymentMethodConfig.default.color  }">
            {{
              commonDict.repaymentMethodConfig[repayDetails[0]?.repymtmd]?.label || commonDict.repaymentMethodConfig.default.label
            }}
          </a-tag>
        </a-descriptions-item>
        <a-descriptions-item label="本期应还" :span="3">
          本金：
          <Balance :amount="repayDetails[0]?.crnrpyblamtb" inline/>
          + 利息：
          <Balance :amount="repayDetails[0]?.crnrpyblamtl" inline/>
        </a-descriptions-item>
        <a-descriptions-item label="剩余应还" :span="3">

          本金：
          <Balance :amount="repayDetails[0]?.rmanpnpamt" inline/>
          + 利息：
          <Balance :amount="repayDetails[0]?.crnrpyblamtl" inline/>
          <a-popover>
            <a-icon type="info-circle"></a-icon>
            <template #content>
              <a-list>
                <a-list-item v-if='repayDetails[0]?.actintamt'>
                  应收利息
                  <Balance :amount="repayDetails[0]?.actintamt" inline/>
                </a-list-item>
                <a-list-item v-if='repayDetails[0]?.intamt'>
                  本金利息
                  <Balance :amount="repayDetails[0]?.intamt" inline/>
                </a-list-item>
                <a-list-item v-if='repayDetails[0]?.adlint'>
                  应收复息
                  <Balance :amount="repayDetails[0]?.adlint" inline/>
                </a-list-item>
                <a-list-item v-if='repayDetails[0]?.ddcint'>
                  催收利息
                  <Balance :amount="repayDetails[0]?.ddcint" inline/>
                </a-list-item>
                <a-list-item v-if='repayDetails[0]?.netint'>
                  催收复利
                  <Balance :amount="repayDetails[0]?.netint" inline/>
                </a-list-item>
                <a-list-item v-if='repayDetails[0]?.exprtnint'>
                  待收利息
                  <Balance :amount="repayDetails[0]?.exprtnint" inline/>
                </a-list-item>
                <a-list-item v-if='repayDetails[0]?.rpybl0dueint'>
                  待收复利
                  <Balance :amount="repayDetails[0]?.rpybl0dueint" inline/>
                </a-list-item>
              </a-list>
            </template>
          </a-popover>
        </a-descriptions-item>
      </a-descriptions>

      <template slot="footer">
        <a-button type="primary" @click="repayVisible=false">关闭</a-button>
      </template>
    </a-modal>

    <a-modal v-model="repaymentVisible" width="30%" @cancel="repaymentCancel" :closable="false" title="还款">
      <a-form-model :model="repayment" :label-col="repaymentlabelCol" :wrapper-col="repaymentwrapperCol">


        <a-form-model-item label="账号">
          <a-input v-model="repayment.accountNo" disabled/>
        </a-form-model-item>

        <a-form-model-item label="户名">
          <a-input v-model="repayment.accountName" disabled/>
        </a-form-model-item>

        <a-form-model-item label="借据号">
          <a-input v-model="repayment.loanacctno" disabled/>
        </a-form-model-item>


        <a-form-model-item label="合同编号">
          <a-input v-model="repayment.ctrno" disabled/>
        </a-form-model-item>

        <a-form-model-item label="还款金额">
          <input-balance v-model="repayment.repymtcorpus"
                         :max=repayment.repymtcorpusMax
                         max-str='全额'
                         style="width: 300px;"
                         align-left></input-balance>
        </a-form-model-item>
        <a-form-model-item label="验证码">
          <paymentSms :verify-code.sync="repayment.verifyCode"
                      model-no="102006"
                      :mobile="accountInfo.mobile"
                      :channel-no="accountInfo.channelNo"
                      :account-name="accountInfo.accountName"
                      :account-no="accountInfo.accountNo"
                      :pay-amount="repayment.repymtcorpus"
                      :disabled="!smsEnable"

          ></paymentSms>
        </a-form-model-item>

      </a-form-model>

      <template slot="footer">
        <a-button type="primary" @click="repaymentSubmit">
          提交
        </a-button>
        <a-button style="margin-left: 10px;" @click="repaymentCancel">
          取消
        </a-button>
      </template>
    </a-modal>
  </div>


</template>

<script>
import WalletInfo from '@/view/components/WalletInfo.vue';
import LcfsPagination from "@/view/components/LcfsPagination.vue";
import InputBalance from "@/view/components/InputBalance.vue";
import PaymentSms from "@/view/components/PaymentSms.vue";
import Balance from "@/view/components/Balance.vue";
import {commonDict} from "@/utils/bizDict/commonDict";

export default {
  name: "CreditLoanAndRepayRecord",
  components: {Balance, PaymentSms, InputBalance, WalletInfo, LcfsPagination},
  computed: {
    commonDict() {
      return commonDict
    },
    smsEnable() {
      return Number(this.repayment.repymtcorpus) > 0
    },
  },
  data() {
    return {
      labelCol: {span: 9},
      wrapperCol: {span: 15},

      activeKey: "loan",

      accountInfo: {},

      repayVisible: false,
      repayDetails: [],

      repaymentlabelCol: {span: 5},
      repaymentwrapperCol: {span: 13},
      repaymentVisible: false,
      repayment: {
        accountNo: '',
        accountName: '',
        verifyCode: '',
        loanacctno: '',
        repymtmd: '',
        ctrno: '',
        repymtcorpus: 0,
        repymtcorpusMax: 0,
      },


      loanPagination: {pageNo: 1, pageSize: 10, total: 0},
      loanData: [],
      loanForm: {
        tradeDate: '',
        contractNo: '',
        loanacctno: '',
        accountNoSk: '',
      },
      loanColumns: [
        {
          title: 'No',
          dataIndex: 'No',
          align: 'center',
          width: 50,
          customRender: (text, record, index) =>
              `${Number(this.loanPagination.pageNo - 1) * Number(this.loanPagination.pageSize) + Number(index + 1)}`
        },
        {
          title: "系统流水号",
          dataIndex: "sysSerialNo",
          width: 150,
          ellipsis: true,
          align: "center"
        },
        {
          title: "提款日期",
          dataIndex: "tradeDate",
          width: 80,
          align: "center"
        },
        {
          title: '合同编号',
          dataIndex: 'contractNo',
          align: 'center',
          width: 100
        },
        {
          title: "借据号",
          dataIndex: "loanacctno",
          width: 100,
          ellipsis: true,
          align: "center",
          customRender: (text, row) => {
            if (!text)
              return '-';
            return <a-button type="link" onClick={() => this.detail(row)}>{text}</a-button>
          }
        },
        {
          title: "提款金额",
          dataIndex: "loanAmount",
          width: 80,
          align: "center",
          customRender: (text) => text ? `¥${Number(text).toLocaleString()}` : '-'
        },
        {
          title: "收款账号",
          dataIndex: "accountNoSk",
          width: 160,
          ellipsis: true,
          align: "center",
          customRender: (text, row) => {
            if (!text)
              return '-';
            return <WalletInfo accountNo={text} accountName={row.accountNameSk} showAccountName={true}></WalletInfo>
          }
        },
        {
          title: "到期日",
          dataIndex: "dealDate",
          width: 80,
          align: "center",
          customRender: (text) => {
            return <a-tag color='red'>{text}</a-tag>
          }
        },
        {
          title: '操作',
          width: 150,
          dataIndex: 'action',
          align: 'center',
          customRender: (text, record) => {
            return <a-button type="link" size="small" onClick={() => this.repaymentDetails(record)}>还款</a-button>
          }
        }
      ],

      repayPagination: {pageNo: 1, pageSize: 10, total: 0},
      repayData: [],
      repayForm: {
        contractNo: '',
        loanAcctNo: '',
        accountNo: '',
        tradeDate: '',
      },
      repayColumns: [
        {
          title: 'No',
          dataIndex: 'No',
          align: 'center',
          width: 70,
          customRender: (text, record, index) =>
              `${Number(this.repayPagination.pageNo - 1) * Number(this.repayPagination.pageSize) + Number(index + 1)}`
        },
        {
          title: "系统流水号",
          dataIndex: "sysSerialNo",
          width: 150,
          ellipsis: true,
          align: "center"
        },
        {
          title: '合同编号',
          dataIndex: 'contractNo',
          align: 'center',
          width: 120
        },
        {
          title: "借据号",
          dataIndex: "loanAcctNo",
          width: 150,
          ellipsis: true,
          align: "center"
        },
        {
          title: "A1账号",
          dataIndex: "accountNo",
          width: 180,
          ellipsis: true,
          align: "center",
          customRender: (text, row) => {
            return <WalletInfo accountNo={text} accountClass='0' accountName={row.accountName}></WalletInfo>
          }
        },
        {
          title: "还款金额",
          dataIndex: "repayAmount",
          width: 120,
          align: "center",
          customRender: (text) => text ? `¥${Number(text).toLocaleString()}` : '-'
        },
        {
          title: "应还本金",
          dataIndex: "needRepayPrincipal",
          width: 120,
          align: "center",
          customRender: (text) => text ? `¥${Number(text).toLocaleString()}` : '-'
        },
        {
          title: "应还利息",
          dataIndex: "needRepayAccrual",
          width: 120,
          align: "center",
          customRender: (text) => text ? `¥${Number(text).toLocaleString()}` : '-'
        },
        {
          title: "还款时间",
          dataIndex: "tradeTime",
          width: 150,
          align: "center"
        },
      ],
    }
  },
  created() {
    // 初始化数据
    this.callback(this.activeKey);


  },
  methods: {


    detail: async function (record) {
      console.log('detail record', record)
      const res = await this.api.creditmanagercreditRepayQueryV2({
        account_no: this.accountInfo.accountNo,
        loanaccno: record.loanacctno
      });
      if (res.code !== 200) {
        this.$message.error(res.info);
        return;
      }
      console.log("detail res", res)
      this.repayDetails = res.data.recode_list.filter(item =>
          //loanaccno 不起效暂时前端过滤
          item.loanacctno === record.loanacctno
      );
      this.repayVisible = true;
    },

    repaymentDetails: async function (record) {
      console.log("repayData", record)

      const res = await this.api.creditmanagercreditRepayQueryV2({
        account_no: this.accountInfo.accountNo,
        loanaccno: record.loanacctno
      });
      if (res.code !== 200) {
        this.$message.error(res.info);
        return;
      }
      console.log("detail res", res)

      this.repayData = res.data.recode_list.filter(item =>
          //loanaccno 不起效暂时前端过滤
          item.loanacctno === record.loanacctno
      );

      this.repayment.accountNo = this.accountInfo.accountNo
      this.repayment.accountName = this.accountInfo.accountName

      this.repayment.loanacctno = this.repayData[0]?.loanacctno
      this.repayment.repymtmd = '1'
      this.repayment.ctrno = this.repayData[0]?.ctrno
      this.repayment.repymtcorpusMax = (Number(this.repayData[0]?.rmanpnpamt) + Number(this.repayData[0]?.crnrpyblamtl)).toFixed(2)

      console.log("  this.repayment", this.repayment)

      this.repaymentVisible = true


    },

    repaymentSubmit: async function () {
      this.repaymentVisible = true
      console.log("repayData", this.repayment)
      this.repayment.repymtmd = this.repayment.repymtcorpusMax === this.repayment.repymtcorpus ? "1" : "0"

      const res = await this.api.repaymentApi({
        ...this.repayment
      });
      if (res.code !== 200) {
        this.$message.error(res.info)
      }
      if (res.code === 200) {
        this.$message.success(res.info)
        this.repaymentVisible = false
        this.repayVisible = false;
        this.loanDetailList()
      }

    },

    repaymentCancel() {
      this.repaymentVisible = false
      this.repayment = {
        repymtcorpus: 0
      }

    },


    callback(key) {
      //获取账户详情
      this.getAccoount()
      if (key == "loan") {
        this.getCreditLoanList()
      } else if (key == "repay") {
        this.getCreditRepayList()
      }
    },

    async getCreditLoanList() {
      console.log("this.loanForm", this.loanForm)
      const res = await this.api.creditLoanInfoPageQueryApi({
        ...this.loanPagination,
        ...this.loanForm,
        loanStatus: '1',
        pageNo: this.loanPagination.pageNo - 1,
        accountNo: this.$route.query.accountNo
      })
      if (res.code !== 200) {
        this.$message.error(res.info)
        return
      }
      this.loanPagination.total = res.data.totalRows
      this.loanData = res.data.data;
    },

    async creditLoanInfoExport() {
      console.log("this.creditLoanInfoExport", this.loanForm)
      let res = await this.api.creditLoanInfoExportApi({
        ...this.loanPagination,
        ...this.loanForm,
        loanStatus: '1',
        pageNo: 0,
        pageSize: 1000,
        accountNo: this.$route.query.accountNo
      })
      this.$uploadfile.ExcelDownload('提款记录', res)
    },

    async getCreditRepayList() {
      const res = await this.api.creditRepayInfoPageQueryApi({
        ...this.repayPagination,
        ...this.repayForm,
        repayStatus: '1',
        pageNo: this.repayPagination.pageNo - 1,
        accountNo: this.$route.query.accountNo
      })
      if (res.code !== 200) {
        this.$message.error(res.info)
        return
      }
      this.repayPagination.total = res.data.totalRows
      this.repayData = res.data.data
    },

    async creditRepayInfoExport() {
      console.log("this.loanForm", this.loanForm)
      let res = await this.api.creditRepayInfoExportApi({
        ...this.loanPagination,
        ...this.loanForm,
        repayStatus: '1',
        pageNo: 0,
        pageSize: 1000,
        accountNo: this.$route.query.accountNo
      })
      this.$uploadfile.ExcelDownload('还款记录', res)
    },

    async getAccoount() {
      console.log("getAccoount")
      const res = await this.api.getByAccountNoApi(this.$route.query.accountNo)
      if (res.code !== 200) {
        this.$message.error(res.info)
        return
      }

      this.accountInfo = {...res.data}
    },


    resetLoanForm() {
      this.loanForm = {
        tradeDate: '',
        contractNo: '',
        loanAcctNo: '',
        accountNoSk: '',
      };
      this.getCreditLoanList();
    },

    resetRepayForm() {
      this.repayForm = {
        contractNo: '',
        loanAcctNo: '',
        accountNo: '',
        tradeDate: '',
      };
      this.getCreditRepayList();
    },

    toBack() {
      this.$router.go(-1);
    }

  },

}
</script>

<style scoped lang="less">
.top-title {
  display: flex;
  align-items: center;

  .left {
    display: flex;
    align-items: center;
    gap: 8px;
  }
}

.loan-repay-record {
  margin-top: 20px;
}

/* 水平表单布局样式 */
.formbox {
  margin-bottom: 20px;
  padding: 16px;
  background: #fafafa;
  border-radius: 6px;
  border: 1px solid #e8e8e8;
}

.horizontal-form {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 16px;
}

.horizontal-form .form-item {
  flex: 1;
  min-width: 150px;
  max-width: 200px;
  margin-bottom: 0;
}

.form-actions {
  display: flex;
  gap: 10px;
  margin-bottom: 0;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .horizontal-form {
    flex-direction: column;
  }

  .horizontal-form .form-item {
    min-width: 100%;
  }

  .form-actions {
    width: 100%;
    justify-content: flex-end;
  }
}

.table-box {
  .pagination-wrapper {
    display: flex;
    justify-content: center;
    margin-top: 16px;
    padding: 12px 0;
    background: #fff;
    border: 1px solid #e8e8e8;
    border-top: none;
    border-radius: 0 0 6px 6px;
  }
}
</style>